<template>
	<div>
		<h2 class="h2-title">Описание результатов</h2>
		<ul class="article-list">
			<li class="article-item" :style="`border-color: ${item.color}`" v-for="(item, i) in data" :key="i">
				<div class="article">
					<h3 class="h3-title">{{item.title}}</h3>
					<p class="article-description" v-html="item.description">
					</p>
				</div>
			</li>
		</ul>
	</div>
</template>

<style lang="css">
	/*Test description*/
	.article-list {
		list-style: none;
		padding: 0;
	}
	.article-item {
		padding-left: 16px;
		border-left: 16px solid;
		margin-bottom: 32px;
	}

	.article-item:last-child {
		margin-bottom: 0;
	}

	.article-description {
		font-size: 14px;
		line-height: 140%;
		color: var(--black-80);
	}
</style>

<script>
	export default {
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				},
				required: true
			}
		}
	}
</script>
